import instance from "./axios";

//大数据中心-欠租情况统计图接口
export const rentArrearsMonitorChart = (para) => {
  return instance.get('/contract/rentArrearsMonitorChart', {params: para})
}
//大数据中心-合同到期预警
export const contractExpireMonitorChart = (para) => {
  return instance.get('/contract/contractExpireMonitorChart', {params: para})
}
//大数据中心-日租金单价区间分布图接口
export const dailyRentalUnitPriceMonitorChart = (para) => {
  return instance.get('/contract/dailyRentalUnitPriceMonitorChart', {params: para})
}

//大数据中心-产业结构分析接口
export const industrialStructureAnalysis = (para) => {
  return instance.get('/industrial/structure/analysis', {params: para})
}
//大数据中心-平台运营数据统计接口
export const platformDataStatistics = (para) => {
  return instance.get('/platform/data/statistics', {params: para})
}
//大数据中心-成交溢价率
export const dealPremiumRateStatistics = (para) => {
  return instance.get('/deal/premium/rate/statistics', {params: para})
}
//大数据中心-资产用途分布
export const getAssetActualUserForStatistics = (para) => {
  return instance.get('/asset/getAssetActualUserForStatistics', {params: para})
}
//大数据中心-租客异常预警
export const lesseesWarnList = (para) => {
  return instance.get('/asset/map/lesseesWarnList', {params: para})
}
//大数据库中心-地图统计和同接口
export const contractMap = (para) => {
  return instance.get('/contract/map', {params: para})
}
//大数据中心-管理资产数排名
export const getManageAssetCountSort = (para) => {
  return instance.post('/bigdata/getManageAssetCountSort',para)
}
//大数据中心-租金营收排名
export const getRentMoneySort = (para) => {
  return instance.post('/bigdata/getRentMoneySort',para)
}
//大数据中心-整体出租率
export const getRentRate = (para) => {
  return instance.post('/bigdata/getRentRate',para)
}
//大数据中心-管理单位出租率分析
export const getManagementRentRate = (para) => {
  return instance.post('/bigdata/getManagementRentRate',para)
}
//大数据中心-出租面积、租金笔数接
export const getRentAreaMoneyCount = (para) => {
  return instance.post('/bigdata/getRentAreaMoneyCount',para)
}

//大数据中心-拍卖消息列表
export const auctionMessageList = (para) => {
  return instance.post('/auction/message/list',  para)
}
